"use strict";

var _objectSpread = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var type_1 = require("./type");

function listSuperReducer(state, action) {
  if (action.type === type_1.ActionType.FETCH_DATA_REQUEST) {
    return _objectSpread(_objectSpread({}, state), {}, {
      loading: true
    });
  }

  if (action.type === type_1.ActionType.FETCH_DATA_SUCCESS) {
    var _action$payload = action.payload,
        data = _action$payload.data,
        numberOfTotalRows = _action$payload.numberOfTotalRows;
    return _objectSpread(_objectSpread({}, state), {}, {
      loading: false,
      data: data,
      numberOfTotalRows: numberOfTotalRows
    });
  }

  if (action.type === type_1.ActionType.FILTER_CHANGE) {
    var _action$payload2 = action.payload,
        filters = _action$payload2.filters,
        pageIdx = _action$payload2.pageIdx;
    return _objectSpread(_objectSpread({}, state), {}, {
      filters: filters,
      pageIdx: pageIdx
    });
  }

  if (action.type === type_1.ActionType.ORDER_CHANGE) {
    var _action$payload3 = action.payload,
        sortDescAsc = _action$payload3.sortDescAsc,
        sortAttribute = _action$payload3.sortAttribute,
        _pageIdx = _action$payload3.pageIdx;
    return _objectSpread(_objectSpread({}, state), {}, {
      sortDescAsc: sortDescAsc,
      sortAttribute: sortAttribute,
      pageIdx: _pageIdx
    });
  }

  if (action.type === type_1.ActionType.PAGE_CHANGE) {
    var _pageIdx2 = action.payload.pageIdx;
    return _objectSpread(_objectSpread({}, state), {}, {
      pageIdx: _pageIdx2
    });
  }

  return state;
}

exports.default = listSuperReducer;